import { GlowLine } from 'root/src/client/v2/common/components/GlowLine';
export const RaceForRewardsHeader = () => {
    return (<div className="px-10 flex flex-col">
			<Title />
			<Description />
		</div>);
};
const Title = () => {
    return (<div className="flex justify-between gap-8 items-center my-0.5">
			<span className="text-3xl font-medium tracking-wider">Race For Rewards</span>
			<TitleGlowLines />
		</div>);
};
const TitleGlowLines = () => {
    return (<div className="flex flex-col gap-1.5">
			<GlowLine className="w-full" variant="purple"/>
			<GlowLine className="w-4/5" variant="green"/>
			<GlowLine className="w-3/5" variant="red"/>
		</div>);
};
const Description = () => {
    return (<div className="my-0.5">
			<span className="text-teal text-lg">Check out what some of our creators are doing on this drop!</span>
		</div>);
};
